import { FC } from 'react';
import {
  Header1,
  Header2,
  Header3,
  Header4,
  Subtitle,
  Body,
  Caption,
  Overline,
  Link,
  Header5,
  Header6,
} from './Typography.styled';
import { TypographyProps } from './Typography.d';

const mapping: any = {
  h1: Header1,
  h2: Header2,
  h3: Header3,
  h4: Header4,
  h5: Header5,
  h6: Header6,
  subtitle: Subtitle,
  body: Body,
  caption: Caption,
  overline: Overline,
  link: Link,
};

export const Typography: FC<TypographyProps> = ({ variant, ...props }) => {
  const Component = mapping[variant];
  return <Component variant={variant} {...props} />;
};
